/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Pagination, TableHeader } from 'components/DataTable'
import TableLength from 'components/DataTable/TableLength'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import { Formik, Form, Field, ErrorMessage } from 'formik'

import CustomHeader from 'components/CustomHeader'
import {
  createTenant,
  deleteTenant,
  getTenants,
  updateTenant,
} from 'store/roleManagement/slice'
import { roleSelector } from 'store/roleManagement/selectors'
import { getPermission } from 'utils/helpers/systemHelpers'
import { PERMISSIONS } from 'model/auth'
import { baseAxios } from 'api/axios'
import { apiEndPoints } from 'api/variables'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'

const createTenantSchema = Yup.object().shape({
  name: Yup.string().required('FirstName is required'),
})

const Tenants = () => {
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [sorting, setSorting] = useState({ field: '', order: '' })
  const [search, setSearch] = useState('')
  const [pageSize, setPageSize] = useState(5)
  const [modalOpenType, setModalOpenType] = useState('add')
  const [selectedTenantId, setSelectedTenantId]: any = useState('')
  const tenantCloseRef = useRef<HTMLButtonElement>(null)
  const dispatch = useDispatch()
  const role = useSelector(roleSelector)

  useEffect(() => {
    dispatch(getTenants({}))
  }, [])

  let tenantData = role.tenants

  const headers = [
    { name: 'No.', field: 'number', sortable: false },
    { name: 'Tenant Name', field: 'contact', sortable: false },
    { name: 'Contact', field: 'contact', sortable: false },
    { name: 'Action', field: 'action', sortable: false },
  ]

  const tenantsData = useMemo(() => {
    let computedTenants: any = tenantData

    if (search) {
      computedTenants = computedTenants.filter((user: { name: string }) =>
        user.name.toLowerCase().includes(search.toLowerCase()),
      )
    }

    setTotalItems(computedTenants.length)

    //Sorting scrolls
    // if (sorting.field) {
    //   const reversed = sorting.order === 'asc' ? 1 : -1
    //   computedMovies = computedMovies.sort(
    //     (a: any, b: any) => {
    //       console.log('reversed - ', reversed * a[sorting.field])
    //       console.log('a - ', a)
    //       console.log('b - ', b)
    //     },
    //     // reversed * a[sorting.field].localeCompare(b[sorting.field]),
    //   )
    // }

    //Current Page slice
    const firstPageIndex = (currentPage - 1) * pageSize
    const lastPageIndex = firstPageIndex + pageSize
    return computedTenants.slice(firstPageIndex, lastPageIndex)
  }, [tenantData, search, currentPage, pageSize])

  const [initialValues] = useState({
    name: '',
    contactDetails: {
      email: '',
      mobile: '',
    },
  })

  const setSelectedTenant = async (value: any) => {
    await clearModal()
    setModalOpenType('edit')
    initialValues.name = value.name
    initialValues.contactDetails.email = value.contactDetails.email
    initialValues.contactDetails.mobile = value.contactDetails.mobile
    setSelectedTenantId(value._id)
  }

  const clearModal = async () => {
    // setTimeout(() => innerModalClear(), 100)

    // const innerModalClear = () => {
    setModalOpenType('add')
    initialValues.name = ''
    initialValues.contactDetails = {
      email: '',
      mobile: '',
    }
    setSelectedTenantId(null)
    // }
  }

  const handleSubmit = async (
    value: {
      name: string
      contactDetails: object
    },
    resetForm: any,
  ) => {
    const resp = await baseAxios.post(
      apiEndPoints.users.createTenantData,
      value,
    )
    if (resp) {
      dispatch(getTenants({}))
      tenantData = role.tenants
      tenantCloseRef.current?.click()
      resetForm()
    }
  }

  const handleUpdate = async (
    value: { name: string; contactDetails: object },
    tenantId: string,
    resetForm: any,
  ) => {
    const resp = await baseAxios.put(
      apiEndPoints.users.updateTenantData(tenantId),
      value,
    )
    if (resp) {
      dispatch(getTenants({}))
      tenantData = role.tenants
      tenantCloseRef.current?.click()
      resetForm()
    }
  }

  const handleDelete = async (value: string) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Are you sure you want to delete?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result: any) => {
      if (result.isConfirmed) {
        toast.promise(
          baseAxios
            .delete(apiEndPoints.users.deleteTenantData(value))
            .then(resp => {
              dispatch(getTenants({}))

              tenantData = role.tenants
            }),
          {
            pending: 'Please wait...',
            success: 'Successfully deleted ',
            error: 'error deleting',
          },
        )
      }
    })
  }

  return (
    <CustomHeader pageName={'Movie List'}>
      <div id="content-page" className="content-page">
        <div className="container-fluid ">
          <div className="row">
            <div className="col-sm-12">
              <div className="iq-card">
                <div className="iq-card-header d-flex justify-content-between">
                  <div className="iq-header-title">
                    <h4 className="card-title">Tenant Lists</h4>
                  </div>
                  {getPermission(PERMISSIONS.CREATE_TENANT) && (
                    <div className="sign-info">
                      <a
                        data-toggle="modal"
                        data-target="#ModalCenter"
                        className="btn btn-primary"
                        onClick={() => clearModal()}
                      >
                        Add Tenant
                      </a>
                    </div>
                  )}
                </div>
                <div className="iq-card-body">
                  <div className="table-view">
                    <TableLength
                      handleLengthChange={(v: any) => setPageSize(parseInt(v))}
                      handleSearchValue={(searchVal: any) =>
                        setSearch(searchVal)
                      }
                    />
                    <table
                      className="data-tables table movie_table"
                      style={{ width: '100%' }}
                    >
                      <TableHeader
                        headers={headers}
                        onSorting={(field: any, order: any) =>
                          setSorting({ field, order })
                        }
                      />
                      <tbody>
                        {tenantsData.map((tenant: any, index: number) => (
                          <tr key={`tenant-${index}`}>
                            <td>{index + 1}</td>
                            <td>{tenant.name}</td>
                            <td>
                              <div className="row">
                                <div className="col-md 12">
                                  {tenant.contactDetails.mobile != null &&
                                    tenant.contactDetails.mobile !=
                                      undefined && (
                                      <p>
                                        Mobile :- {tenant.contactDetails.mobile}
                                      </p>
                                    )}
                                </div>
                                {/* <div className="col-md-12">
                                  {tenant.contactDetails.email != null &&
                                    tenant.contactDetails.email !=
                                      undefined && (
                                      <p>
                                        Email :- {tenant.contactDetails.email}
                                      </p>
                                    )}
                                </div> */}
                              </div>
                            </td>
                            <td>
                              <div className="flex align-items-center list-user-action">
                                {getPermission(PERMISSIONS.UPDATE_TENANT) && (
                                  <a
                                    className="iq-bg-success"
                                    data-placement="top"
                                    title=""
                                    data-toggle="modal"
                                    data-target="#ModalCenter"
                                    data-original-title="Edit"
                                    onClick={() => setSelectedTenant(tenant)}
                                  >
                                    <i className="ri-pencil-line" />
                                  </a>
                                )}
                                {getPermission(PERMISSIONS.DELETE_TENANT) && (
                                  <a
                                    className="iq-bg-primary"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title=""
                                    data-original-title="Delete"
                                    onClick={() => handleDelete(tenant._id)}
                                  >
                                    <i className="ri-delete-bin-line" />
                                  </a>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <Pagination
                      currentPage={currentPage}
                      totalCount={totalItems}
                      pageSize={pageSize}
                      onPageChange={(page: React.SetStateAction<number>) =>
                        setCurrentPage(page)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="ModalCenter"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="ModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <Formik
            initialValues={initialValues}
            validationSchema={createTenantSchema}
            onSubmit={(
              values: {
                name: string
                contactDetails: object
              },
              { resetForm }: any,
            ) => {
              modalOpenType == 'add'
                ? handleSubmit(values, resetForm)
                : handleUpdate(values, selectedTenantId, resetForm)
            }}
          >
            {(formik: any) => {
              const { errors, touched } = formik
              return (
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="ModalCenterTitle">
                      {modalOpenType == 'add' ? 'Add Tenant' : 'Edit Tenant'}
                    </h5>

                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      ref={tenantCloseRef}
                      onClick={() => {
                        setModalOpenType('add')
                        formik.resetForm()
                      }}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <Form>
                      <div className="row">
                        <div className="col-12">
                          <div className="row">
                            <div className="col-md-12 form-group">
                              <Field
                                type="text"
                                name="name"
                                id="name"
                                className="form-control  mb-0"
                                placeholder="Enter Tenant Name"
                              />
                              <ErrorMessage
                                name="name"
                                component="span"
                                className="text-primary"
                              />
                            </div>
                            <div className="col-md-12 form-group">
                              <Field
                                type="text"
                                name="contactDetails.email"
                                id="email"
                                className="form-control  mb-0"
                                placeholder="Enter Tenant Email"
                              />
                              <ErrorMessage
                                name="contactDetails.email"
                                component="span"
                                className="text-primary"
                              />
                            </div>
                            <div className="col-md-12 form-group">
                              <Field
                                type="text"
                                name="contactDetails.mobile"
                                id="mobile"
                                className="form-control  mb-0"
                                placeholder="Enter Tenant Contact"
                              />
                              <ErrorMessage
                                name="contactDetails.mobile"
                                component="span"
                                className="text-primary"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 d-flex justify-content-end align-items-center mt-2">
                          <button type="submit" className="btn btn-primary">
                            {modalOpenType == 'add' ? 'Submit' : 'Update'}
                          </button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              )
            }}
          </Formik>
        </div>
      </div>
    </CustomHeader>
  )
}

export default Tenants
